import { jsx as _jsx } from "react/jsx-runtime";
import { CopyrightCheckerStatus } from '../../../../interfaces/CopyrightCheckerStatus';
import copyrightCheckerDossiersMock from '../../../organisms/table/__mock__/copyrightCheckerDossiers.json';
import { CopyrightCheckerDossiersOverviewView } from './CopyrightCheckerOverview.view';
export default {
    title: 'Pages/copyright-checker/dossiers',
    component: CopyrightCheckerDossiersOverviewView,
    parameters: {
        padding: 0,
    },
};
const Template = args => _jsx(CopyrightCheckerDossiersOverviewView, { ...args });
export const Primary = Template.bind({});
Primary.args = {
    availableStatuses: Object.values(CopyrightCheckerStatus),
    data: copyrightCheckerDossiersMock,
    resData: {
        current_page: 1,
        from: 0,
        last_page: 0,
        links: [],
        path: '',
        per_page: 0,
        to: 0,
        total: 0,
        data: copyrightCheckerDossiersMock,
    },
};
export const NoResults = Template.bind({});
NoResults.args = {
    availableStatuses: Object.values(CopyrightCheckerStatus),
    resData: {
        current_page: 1,
        from: 0,
        last_page: 0,
        links: [],
        path: '',
        per_page: 0,
        to: 0,
        total: 0,
        data: [],
    },
};
